module.exports = __webpack_public_path__ + "static/img/18.d88ffe1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/2/eng/18.png
// module id = ULPX
// module chunks = 0